import React, { ReactElement, Component, useContext, useEffect, useState, useMemo } from "react";
import "./namespace-overview.less";
import { FormattedMessage, injectIntl } from "react-intl";
import { Col, Row, Descriptions, Skeleton } from "antd";
import { left_menu_item, LeftMenuContext, menu_items } from "../../contexts/left-menu";
import { LeftMenuTitleContext } from "../../contexts/left-menu-title";
import { item } from "../../contexts/items";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { http_get, http_request, response_type, destroy_worker } from "../../worker/http-func";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import BreadCrumbs from "../../components/breadcrumb/breadcrumb";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { namespace_info_type_new } from "../../contexts/namespace-info";
import { quota_type, QuotaContext, quota_type_item } from "../../contexts/quota-management";
import { LineChart, XAxis, YAxis, CartesianGrid, Legend, Line, Tooltip, ResponsiveContainer } from "recharts";
import { SideFlyInContext } from "../../contexts/side-menu-fly-in";
// import { upper_case } from "../workspace-overview/workspace-overview";
import { change_unit } from "../global/global";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import DropdownMenuTop from "../../components/dropdown-menu-top/dropdown-menu-top";
import { TypeNameContext } from "../../contexts/type_name";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { metric_values_new, metric_values } from "../../worker/function/interfaces";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { clusters_type_item, ClusterContext } from "../../contexts/clusters";
import { UnitContext } from "../../contexts/unit";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { formatDate } from "../../pages/user-management/user-util";
import { ThemeContext } from "../../contexts/theme";
import { TableListModalContext } from "../../components/table-list/table-list";
import TableListModal from "../../components/table-list-modal/table-list-modal";
import { table_list_modal_type, TableListModalTypeContext } from "../../contexts/table_list_modal";

const NamespaceOverview: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const set_workspaces: React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>> = useContext(WorkspaceContext)[1],
    [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(
      NamespaceContext
    ),
    set_clusters: React.Dispatch<React.SetStateAction<clusters_type_item[]>> = useContext(ClusterContext)[1],
    workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
    [quotas, set_quotas]: [quota_type["items"], React.Dispatch<React.SetStateAction<quota_type["items"]>>] = useContext(QuotaContext),
    set_left_menu_items: React.Dispatch<React.SetStateAction<left_menu_item[]>> = useContext(LeftMenuContext)[1],
    set_left_menu_title: React.Dispatch<React.SetStateAction<string>> = useContext(LeftMenuTitleContext)[1],
    [side_fly_in, set_side_fly_in]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(SideFlyInContext),
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
    theme: string = useContext(ThemeContext)[0],
    [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(TableListModalTypeContext),
    [namespace_info, set_namespace_info]: [namespace_info_type_new, React.Dispatch<React.SetStateAction<namespace_info_type_new>>] = useState(
      {} as namespace_info_type_new
    ),
    [namespace_info_panel, set_namespace_info_panel]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState([] as JSX.Element[]),
    [physical_resource_usage, set_physical_resource_usage]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState(
      [] as JSX.Element[]
    ),
    [metric_data, set_metric_data]: [metric_values_new, React.Dispatch<React.SetStateAction<metric_values_new>>] = useState({} as metric_values_new),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    unit_provide: string = useContext(UnitContext)[0],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(TypeNameContext),
    user_info_isEmpty: boolean = user_info.role ? false : true,
    { formatMessage } = useMemo(() => props.intl, [props]);
  type metric_key_type = keyof metric_values;

  useEffect(
    () => () => {
      destroy_worker();
    },
    []
  );
  useEffect((): void => {
    user_info.role !== "" &&
      datacenter_name &&
      http_get(
        "namespace_overview_page",
        ["clusters", set_clusters, "workspaces", set_workspaces, "namespaces", set_namespaces, "namespacequotas", set_quotas],
        user_info.role,
        `${user_info.subscription_id}&type=${type_name}`,
        datacenter_name,
        (cluster_selected || {}).name || ""
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_workspaces, set_namespaces, set_quotas, user_info.role, user_info.subscription_id, set_clusters, type_name]);

  useEffect(() => {
    // 切换订阅号，当type_name为undefined
    !type_name &&
      (cluster_selected?.labels?.type === "dedicate" || cluster_selected?.labels?.type === "shared") &&
      set_type_name(cluster_selected?.labels?.type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_type_name, cluster_selected?.labels?.type]);

  useEffect((): void => {
    // if (user_info.role !== '' && cluster_selected?.name)
    //     http_request('workspaces', set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true);
    (async () => {
      if (cluster_selected?.name && datacenter_name) {
        const { name }: item = cluster_selected;
        if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
          const workspacenames: { name: string; id: string }[] = ((await http_request(
            "workspacenames",
            props,
            undefined,
            `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`,
            0,
            user_info.role,
            user_info.subscription_id,
            datacenter_name,
            cluster_selected.name || "",
            undefined,
            undefined,
            undefined,
            undefined,
            true
          )) as response_type).items as { name: string; id: string }[];
          workspacenames &&
            set_workspaces(
              workspacenames.map(({ name, id }) => {
                return { metadata: { name: id, labels: { name } } } as workspaces_type_item;
              })
            );

        } else {
          name &&
            user_info.role !== "" &&
            datacenter_name !== "" &&
            http_request(
              "workspaces",
              props,
              set_workspaces,
              `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`,
              0,
              user_info.role,
              user_info.subscription_id,
              datacenter_name,
              cluster_selected.name || "",
              undefined,
              undefined,
              undefined,
              undefined,
              true
            );
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper, set_workspaces]);

  useEffect((): void => {
    if (user_info.role !== "" && workspace_selected?.name && datacenter_name) {
      http_request(
        "namespaces",
        props,
        set_namespaces,
        `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/workspace/${workspace_selected.name}/namespaces`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        (cluster_selected || {}).name || "",
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
      http_request(
        "namespacequotas",
        props,
        set_quotas,
        `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/workspace/${workspace_selected.name}/namespacequotas`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        (cluster_selected || {}).name || ""
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, workspace_selected?.name, set_namespaces, set_quotas, user_info.role, user_info.subscription_id]);

  useEffect((): void => {
    if (!user_info_isEmpty && namespace_selected?.name && datacenter_name) {
      (async () => {
        set_namespace_info(
          (await http_request(
            "namespace_info",
            props,
            undefined,
            `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/namespace/${namespace_selected.name}/info`,
            0,
            user_info.role,
            user_info.subscription_id,
            datacenter_name,
            (cluster_selected || {}).name || "",
            undefined,
            undefined,
            undefined,
            undefined,
            true
          )) as namespace_info_type_new
        );
      })();
      http_request(
        "namespace_metric",
        props,
        set_metric_data,
        `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/namespace/${namespace_selected.name}/metric`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        (cluster_selected || {}).name || ""
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespace_selected?.name, user_info_isEmpty, cluster_selected?.name, user_info.subscription_id]);

  useEffect((): void => {
    set_left_menu_title("Namespace");
    set_left_menu_items(menu_items[2]);
  }, [set_left_menu_title, set_left_menu_items]);

  useEffect((): void => {
    if (!namespaces || namespaces?.length === 0) {
      set_namespace_info({} as namespace_info_type_new);
    }
  }, [namespaces, set_namespace_info]);

  useEffect(
    (): void => {
      if (namespace_info) {
        const namespace_info_panel_new: JSX.Element[] = [],
          namespace = namespace_selected as namespaces_type_item["metadata"] | undefined,
          metadata = (
            (Array.isArray(namespaces) && namespaces.find((namespace_2: namespaces_type_item) => namespace_2.metadata.name === namespace?.name)) ||
            {}
          ).metadata,
          quota_name: string | undefined = namespace && metadata && (metadata.labels || {}).namespacequota,
          quota: quota_type_item = quotas.filter((quo) => quo.metadata.name === quota_name)[0],
          namespace_info_arr: string[] | undefined = [
            `${formatMessage({ id: "quota" })}`,
            metadata ? (quota_name ? quota_name : "Empty") : "",
            "Pod",
            namespace_info.usedPod ? Number(namespace_info.usedPod).toFixed(0) : "",
            "Service",
            namespace_info.usedService ? namespace_info.usedService : "",
            "Secret",
            namespace_info.usedSecret ? namespace_info.usedSecret : "",
            "ConfigMap",
            namespace_info.usedConfigmap ? namespace_info.usedConfigmap : "",
            "CPU",
            namespace_info.usedCPU ? `${Number(namespace_info.usedCPU).toFixed(2)} core` : "",
            `${formatMessage({ id: "memory" })}`,
            namespace_info.usedMemory ? `${change_unit(namespace_info.usedMemory, unit_provide, false)} ${unit_provide}` : "",
            'GPU',
            namespace_info.usedGPU || "",
            `${formatMessage({ id: "update_time" })}`,
            namespace_info.uptime && Number(namespace_info.uptime) ? formatDate(Number(namespace_info.uptime)) : "",
          ];
        for (let i = 0; i < namespace_info_arr.length; i += 2)
          namespace_info_panel_new[i] = (
            <Col
              className={`resource_card no-pad d-flex justify-center align-items-center ${namespace_info_arr[i] === "Update Time" ? "flex-2" : "flex-1"}`}
              key={namespace_info_arr[i]}
            >
              <Row className="resource_info d-flex border">
                <Col className="strong text-ellipsis" title={namespace_info_arr[i + 1]}>
                  {namespace_info_arr[i + 1] || (
                    <Skeleton className="ant-col-sm-16 ant-col-sm-offset-4" title={{ width: "100%" }} paragraph={{ rows: 0 }} active />
                  )}
                </Col>
                <Col className="span text-ellipsis">{namespace_info_arr[i]}</Col>
              </Row>
            </Col>
          );
        set_namespace_info_panel(namespace_info_panel_new);

        const physical_resource_usage_new: JSX.Element[] = [],
          physical_resource_usage_arr: string[] | undefined = [
            "CPU",
            namespace_info.usedCPU ? `${Number(namespace_info.usedCPU).toFixed(2)}` : "",
            namespace_info.totalCPU ? `${namespace_info.totalCPU === "*" ? "*" : Number(namespace_info.totalCPU).toFixed(2)}` : "",
            "usedCPU",
            "Memory",
            namespace_info.usedMemory ? `${change_unit(namespace_info.usedMemory, unit_provide, false)}` : "",
            namespace_info.totalMemory ? `${namespace_info.totalMemory === "*" ? "*" : change_unit(namespace_info.totalMemory, unit_provide, false)}` : "",
            "usedMemory",
            "Rootfs",
            namespace_info.usedRootfs ? `${change_unit(namespace_info.usedRootfs, unit_provide, false)}` : "",
            namespace_info.totalRootfs ? `${namespace_info.totalRootfs === "*" ? "*" : change_unit(namespace_info.totalRootfs, unit_provide, false)}` : "",
            "usedRootfs",
            "Pod",
            namespace_info.usedPod ? Number(namespace_info.usedPod).toFixed(0) : "",
            namespace_info.totalPod ? `${namespace_info.totalPod === "*" ? "*" : Number(namespace_info.totalPod).toFixed(0)}` : "",
            "usedPod",
            "PVC Disk",
            namespace_info.usedDisk ? `${change_unit(namespace_info.usedDisk, unit_provide, false)}` : "",
            namespace_info.totalDisk ? `${namespace_info.totalDisk === "*" ? "*" : change_unit(namespace_info.totalDisk, unit_provide, false)}` : "",
            "usedDisk",
          ];
        // get_float: (num: number) => number = (num: number): number => parseFloat(num.toFixed(3));
        let name: string,
          used: number,
          total: number,
          usage_display: string,
          used_str: string,
          total_str: string,
          metric_key: metric_key_type,
          unit: string,
          metric_data_each: object[];
        for (let i = 0; i < physical_resource_usage_arr.length; i += 4) {
          name = physical_resource_usage_arr[i];
          used_str = physical_resource_usage_arr[i + 1];
          total_str = physical_resource_usage_arr[i + 2]
            ? physical_resource_usage_arr[i + 2].indexOf("*") === -1
              ? physical_resource_usage_arr[i + 2]
              : "Unlimited"
            : "";
          used = used_str ? Number(used_str) : 0;
          total = total_str ? Number(total_str) : 1;
          usage_display = physical_resource_usage_arr[i + 1];
          metric_key = physical_resource_usage_arr[i + 3] as metric_key_type;
          unit = name === "CPU" || name === "Pod" ? "" : unit_provide;
          metric_data_each =
            metric_key === "usedCPU" || metric_key === "usedPod"
              ? metric_data[metric_key]?.data
              : metric_data[metric_key] && (metric_data[metric_key][unit_provide] as object[]);
          const interval: number =
            (metric_key === "usedCPU" || metric_key === "usedPod"
              ? metric_data[metric_key]?.interval
              : metric_data[metric_key] && (metric_data[metric_key].interval as number)) || 0;

          physical_resource_usage_new[i] = (
            <Col className='cluster_status_card' key={name}>
              <Row className="cluster_status_row d-flex flex-wrap">
                <Col sm={5}>
                  <CircularProgressbar
                    value={total_str === "Unlimited" ? 0 : used}
                    maxValue={total === 0 || total_str === "Unlimited" ? Infinity : total}
                    strokeWidth={12}
                    text={`${total_str === "Unlimited" ? "Unlimited" : total === 0 ? "0.00%" : `${((used / total) * 100).toFixed(2)}%`}`}
                    className="progress_circle"
                    styles={buildStyles({ trailColor: `${theme === 'black_gray' ? 'dcdce0' : 'dcdce0'}` })}
                  />
                </Col>
                <Col sm={19}>
                  <Row className="status_detail">
                    <Col sm={24} className="font-w-6">
                      {formatMessage({ id: physical_resource_usage_arr[i].toLocaleLowerCase().replace(" ", "_") })}
                    </Col>
                    <Col
                      sm={24}
                      className="d-flex"
                      title={`${Number(usage_display) ? usage_display : "0"} / ${total ? total.toString() : total_str} ${
                        name === "CPU" ? "core" : name === "Pod" ? "" : unit_provide
                      }`}
                    >
                      <span className="font-w-6 font-20 text-ellipsis">
                        {usage_display
                          ? Number(usage_display)
                            ? usage_display
                            : "0"
                          : "" || <Skeleton title={{ width: "50px" }} paragraph={{ rows: 0 }} active />}
                      </span>
                      <span className="px-6 vertical-middle">/</span>
                      <span className="text_total_span text-ellipsis">
                        {total_str ? (total ? total.toString() : total_str) : "" || <Skeleton title={{ width: "50px" }} paragraph={{ rows: 0 }} active />}
                      </span>
                      <span className="pl-4 vertical-middle">{name === "CPU" ? "core" : name === "Pod" ? "" : unit_provide}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="line_chart_row">
                <ResponsiveContainer width="90%" height={180}>
                  <LineChart width={200} height={150} data={metric_data_each}>
                    <XAxis dataKey="time" />
                    <YAxis
                      label={{ value: `${unit}`, angle: 0, position: "insideTop" }}
                      domain={[(dataMin) => (dataMin - interval).toFixed(2), (dataMax) => (dataMax + interval / 2).toFixed(2)]}
                      allowDataOverflow={false}
                      interval="preserveStart"
                    />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dot={false} dataKey={name} stroke={theme === 'dark_blue' ? '#2E7BBF' : theme === 'black_gray' ? '#6c748b' : '#4fa1e8'} />
                  </LineChart>
                </ResponsiveContainer>
              </Row>
            </Col>
          );
        }

        const physical_resource_quota_new: JSX.Element[] = [],
          physical_resource_quota_arr: string[] = [
            // "compute_resource_quota",
            "compute_resource_quota",
            "requestCPU",
              quota === undefined ? "Unlimited" : quota.spec.quotas.requestCPU ? quota.spec.quotas.requestCPU + " Core" : "Unlimited",
            "limitsCPU",
            quota === undefined ? "Unlimited" : quota.spec.quotas.limitCPU ? quota.spec.quotas.limitCPU + " Core" : "Unlimited",
            "requestMemory",
            `${quota === undefined
              ? "Unlimited"
              : quota.spec.quotas.requestMemory
                ? `${quota.spec.quotas.requestMemory === "*" ? "Unlimited" : change_unit(quota.spec.quotas.requestMemory, unit_provide, false).toFixed(2)
                } ${unit_provide}`
                : "Unlimited"
            }`,
            "limitsMemory",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.limitMemory
                ? `${
                    quota.spec.quotas.limitMemory === "*" ? "Unlimited" : change_unit(quota.spec.quotas.limitMemory, unit_provide, false).toFixed(2)
                  } ${unit_provide}`
                : "Unlimited"
            }`,
            "GPU",
            quota === undefined ? "Unlimited" : quota.spec.quotas.gpu || "Unlimited",
            // "storage_resource_quota",
            "storage_resource_quota",
            "requestRootfs",
            `${quota?.spec?.quotas?.requestRootfs || quota?.spec?.quotas?.requestRootfs === '0' ?
              (quota?.spec.quotas.requestRootfs !== "Unlimited" ? `${change_unit(quota?.spec.quotas.requestRootfs, unit_provide, false).toFixed(2)} ${unit_provide}` : "Unlimited")
              : "Unlimited"
            }`,
            "limitsRootfs",
            `${quota?.spec?.quotas?.limitsRootfs || quota?.spec?.quotas?.limitsRootfs === '0' ?
              (quota?.spec.quotas.limitsRootfs !== "Unlimited" ? `${change_unit(quota?.spec.quotas.limitsRootfs, unit_provide, false).toFixed(2)} ${unit_provide}` : "Unlimited")
              : "Unlimited"
            }`,
            "PVC Disk",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.limitsDisk
                ? `${
                    quota.spec.quotas.limitsDisk === "*" ? "Unlimited" : change_unit(quota.spec.quotas.limitsDisk, unit_provide, false).toFixed(2)
                  } ${unit_provide}`
                : "Unlimited"
            }`,
            "PVC",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.persistentvolumeclaims
                ? `${quota.spec.quotas.persistentvolumeclaims === "*" ? "Unlimited" : quota.spec.quotas.persistentvolumeclaims}`
                : "Unlimited"
            }`,
            "\xa0",
            "\xa0",
            // "object_count_quota",
            "object_count_quota",
            "services",
            quota === undefined ? "Unlimited" : quota.spec.quotas.services ? quota.spec.quotas.services : "Unlimited",
            "secrets",
            quota === undefined ? "Unlimited" : quota.spec.quotas.secrets ? quota.spec.quotas.secrets : "Unlimited",
            "configMaps",
            quota === undefined ? "Unlimited" : quota.spec.quotas.configmaps ? quota.spec.quotas.configmaps : "Unlimited",
            "pods",
            quota === undefined ? "Unlimited" : quota.spec.quotas.pods ? quota.spec.quotas.pods : "Unlimited",
            "\xa0",
            "\xa0"
          ];

        let keys: string,
          // value: string,
          first_label: string,
          first_value: string,
          second_label: string,
          second_value: string,
          third_label: string,
          third_value: string,
          fourth_label: string,
          fourth_value: string,
          fifth_label: string,
          fifth_value: string;
        for (let a = 0; a < physical_resource_quota_arr.length; a += 11) {
          keys = physical_resource_quota_arr[a];
          // value = physical_resource_quota_arr[a + 1];
          first_label = physical_resource_quota_arr[a + 1];
          first_value = physical_resource_quota_arr[a + 2];
          second_label = physical_resource_quota_arr[a + 3];
          second_value = physical_resource_quota_arr[a + 4];
          third_label = physical_resource_quota_arr[a + 5];
          third_value = physical_resource_quota_arr[a + 6];
          fourth_label = physical_resource_quota_arr[a + 7];
          fourth_value = physical_resource_quota_arr[a + 8];
          fifth_label = physical_resource_quota_arr[a + 9];
          fifth_value = physical_resource_quota_arr[a + 10];
          physical_resource_quota_new[a] = (
            <Col xs={24} md={12} lg={8} className="quota_usage" key={keys}>
              <div className="quota_usage_border">
                <div className="quota_usage_title"><FormattedMessage id={keys} /></div>
                <Descriptions bordered size="small" column={{ xxl: 2, xl: 1, lg: 1, md: 1, sm: 2, xs: 1 }}>
                  {/* <Descriptions.Item className="text-ellipsis" label={keys.includes("&") ? `\xa0` : <FormattedMessage id={value} />} span={3} key={keys + `${a}`}>
                    {value.includes("&") ? `\xa0` : <FormattedMessage id={value} />}
                  </Descriptions.Item> */}
                  <Descriptions.Item className={`text-ellipsis`} label={<span title={first_label}>{first_label}</span>} span={1} key={first_label + `${a + 1}`}>
                    {first_value.includes("&") ? `\xa0` : <span title={first_value}>{first_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item
                    className={`text-ellipsis`}
                    label={<span title={second_label}>{second_label}</span>}
                    span={1}
                    key={second_label + `${a + 2}`}
                  >
                    {second_value.includes("&") ? `\xa0` : <span title={second_value}>{second_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item className={`text-ellipsis`} label={<span title={third_label}>{third_label}</span>} span={1} key={third_label + `${a + 3}`}>
                    {third_value.includes("&") ? `\xa0` : <span title={third_value}>{third_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item
                    className={`text-ellipsis`}
                    label={<span title={fourth_label}>{fourth_label}</span>}
                    span={1}
                    key={fourth_label + `${a + 4}`}
                  >
                    {fourth_value.includes("&") ? `\xa0` : <span title={fourth_value}>{fourth_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item className={`text-ellipsis`} label={<span>{fifth_label}</span>} span={1} key={fifth_label + `${a + 5}`}>
                    {fifth_value.includes("&") ? `\xa0` : <span title={fifth_value}>{fifth_value}</span>}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            </Col>
          );
        }

        set_physical_resource_usage([
          <div key="phy-usage">
            <div className="grid grid_first">{physical_resource_usage_new}</div>
            <Row className="mt-20">{physical_resource_quota_new}</Row>
          </div>,
        ]);
      }
    },
    // eslint-disable-next-line
    [namespace_info, namespaces, workspace_selected, metric_data, unit_provide, formatMessage, theme]
  );

  return (
    <TableListModalContext.Provider value={[table_list_modal, set_table_list_modal]}>
      <Col sm={24}>
        <TableListModal />
        <Row className="box_rounded card_title breadcard_title pointer breadcrumb_sticky">
          <Col sm={1}>
            {side_fly_in ? (
              <MenuUnfoldOutlined
                className="pl-10 mt-5"
                onClick={() => {
                  set_side_fly_in(!side_fly_in);
                }}
              />
            ) : (
                <MenuFoldOutlined
                  className="pl-10 mt-5"
                  onClick={() => {
                    set_side_fly_in(!side_fly_in);
                  }}
                />
              )}
          </Col>
          <Col sm={22} pull={1} className="px-30">
            <BreadCrumbs />
          </Col>
        </Row>
        <div className="px-6">
          <div className="mb-5">
            <DropdownMenuTop />
          </div>
          <div className="card box_rounded border">
            <div className="card_title card_underline">
              <FormattedMessage id="resource_information" />
            </div>
            <div className="d-flex res_info">{namespace_info_panel}</div>
          </div>
        </div>
        <div className="px-6">
          <div className="card box_rounded border">
            <div className="card_title card_underline">
              <FormattedMessage id="physical_resource_usage" />
            </div>
            <div className="d-flex">{physical_resource_usage}</div>
          </div>
        </div>
        {/* <Row className="px-6">
                <Col lg={24} className="card box_rounded border">
                    <div className="card_title card_underline">Applications</div>
                </Col>
            </Row> */}
      </Col>
    </TableListModalContext.Provider>
  );
};

export default injectIntl(NamespaceOverview);
